// extracted by mini-css-extract-plugin
export default {"tabsContainer":"index-module__DQAiD","orgHeader":"index-module__BKbDX","ant-tabs-tab-active":"index-module__kh53R"};